import { Component, OnInit } from '@angular/core'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
} from '../../../core/models/contact-type.model'
import { ClientEditComponent } from '../../../features/customer/client-edit/client-edit.component'
import { LegalEntityClientService } from '../../../core/services/customer/legal-entity-client/legal-entity-client.service'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { responseDefaultForm } from '../../../shared/utils/utils'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'
import { ModalDeleteClientComponent } from '../../../features/customer/modal-delete-client/modal-delete-client.component'
import { ClientConvertSubClientComponent } from '../../../features/customer/client-convert-subclient/client-convert-subclient.component'
import { ClientConvertSupplierComponent } from '../../../features/customer/client-convert-supplier/client-convert-supplier.component'
import { SupplierService } from '../../../core/services/person/supplier/supplier.service'
import { ResponseRequestModel } from '../../../core/models/response.model'

@Component({
  selector: 'legal-entity-client',
  imports: [
    FormSearchComponent,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    FormClientSearchComponent,
    MatPaginatorModule,
  ],
  templateUrl: './legal-entity-client.component.html',
  styleUrl: './legal-entity-client.component.scss',
  standalone: true,
  providers: [LegalEntityClientService, SupplierService],
})
export class LegalEntityClientComponent implements OnInit {
  constructor(
    private legalEntityClientService: LegalEntityClientService,
    private supplierService: SupplierService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  columns: any[] = [
    // { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'name',
      key: 'nomeFantasia',
      description: 'Nome Fantasía',
    },
    {
      keyColumn: 'corporate_name',
      key: 'razaoSocial',
      description: 'Razão social',
    },
    {
      keyColumn: 'cnpj',
      key: 'cnpj',
      description: 'CNPJ/CPF',
    },
    {
      keyColumn: 'action',
      key: {
        edit: false,
        delete: false,
        convertClient: false,
        convertToSupplier: false,
      },
      description: 'Ações',
    },
  ]

  listSearch: any = [
    { id: 'nomeFantasia', description: 'Nome', type: 'string', visible: true },
    // { id: 'cpf', description: 'CPF', type: 'string', visible: true },
    {
      id: 'razaoSocial',
      description: 'Razão Social',
      type: 'string',
      visible: true,
    },
    { id: 'cnpj', description: 'Cpf/Cnpj', type: 'string', visible: true },
    {
      id: 'inscricaoMunicipal',
      description: 'Inscrição Municipal',
      type: 'string',
      visible: false,
    },
    {
      id: 'inscricaoEstadual',
      description: 'Inscrição Estadual',
      type: 'string',
      visible: false,
    },
  ]

  inputSearch: any = { type: '', search: '' }
  searchForm: any = { search: false, model: {} }

  screen = 'clientes pessoa juridica'

  // pessoa_id de quem ja tem o papel de fornecedor, para desabilitar o "Virar fornecedor".
  supplierPersonIds = new Set<number>()

  ngOnInit() {
    this.checkColumnAction()
    this.getSupplierPersonIds()
    this.getListItems()
  }

  getSupplierPersonIds() {
    this.supplierService.listSupplier().subscribe({
      next: (response: ResponseRequestModel) => {
        const list = Array.isArray(response?.data) ? response.data : []
        this.supplierPersonIds = new Set<number>(
          list.map((ele: any) => ele.pessoaId),
        )
        this.applyRoleFlags()
      },
      // Sem permissao na rota de fornecedor o conjunto fica vazio e o botao segue habilitado:
      // quem tentar converter uma empresa que ja e fornecedor recebe o 409 do back.
      error: () => {},
    })
  }

  applyRoleFlags() {
    for (const item of this.itemsList) {
      item.jaEhFornecedor = this.supplierPersonIds.has(item.pessoaId)
    }
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('remover'),
        convertClient: true,
        convertToSupplier: true,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  // search(event: any) {
  //   let search = event
  //   this.page = 1
  //   if (search) {
  //     this.searchForm.descricao = search
  //     this.searchListItems()
  //   } else {
  //     this.getListItems()
  //   }
  // }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }

  createModel(element: any) {
    const model: any = {}
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
    this.applyRoleFlags()
  }

  getListItems() {
    this.loading = true
    this.legalEntityClientService
      .listPagedLegalEntityClient(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.legalEntityClientService
      .searchPagedLegalEntityClient(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(ClientEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { type: 'legal-entity-client', item: item },
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  convertClientItem(item: any) {
    const dialogRef = this.dialog.open(ClientConvertSubClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '90vw',
      width: '100%',
      maxHeight: '90vh',
      data: { type: 'legal-entity-client', item: item },
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  convertToSupplierItem(item: any) {
    const dialogRef = this.dialog.open(ClientConvertSupplierComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '90vw',
      width: '100%',
      maxHeight: '90vh',
      data: { type: 'legal-entity-client', item: item },
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.getSupplierPersonIds()
        this.uploadList()
      }
    })
  }

  deleteItem(item: any) {
    const dialogRef = this.dialog.open(ModalDeleteClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '40vw',
      width: '100%',
      maxHeight: '90vh',
      data: { item: item, typeClient: 'client' },
    })
    dialogRef.componentInstance.responseDelete.subscribe((response) => {
      if (response.delete) {
        this.uploadList()
      }
    })
  }
}
